import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useEffect } from 'react';

/* eslint-disable */

// see https://usehooks.com/useMedia/
function useMedia(queries, values, defaultValue) {
  // State update function
  function match() {
    var query;
    if (typeof window !== 'undefined') {
      // Get first media query that matches
      query = queries.findIndex(function (q) {
        return window.matchMedia(q).matches;
      });
      // return corresponding value for query
    }

    return values[query] || defaultValue;
  }

  // State and setter for current value
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    set = _useState2[1];
  useEffect(function () {
    // Update state on window resize and first mount
    // Usage of match function defined outside of useEffect ...
    // ... ensures that it has current values of arguments.
    set(match);
    var handler = function handler() {
      return set(match);
    };
    window.addEventListener('resize', handler);
    // Remove event listener on cleanup
    return function () {
      return window.removeEventListener('resize', handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty array ensures effect is only run on mount and unmount

  return value;
}

export { useMedia as default };
